import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { progressEditor } from '../../../assets/js/field_config/editor-inline-gantt';

const progressCol = (gantt, t) => {
  const name = 'progress';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.progress', 'Avance'),
    align: 'center',
    resize: true,
    width: '70',
    editor: progressEditor,
    template: (activity) => {
      const hasChild = gantt.hasChild(activity.id);
      const isOdd = gantt.oddColsConfig?.progress || false;
      const lang = t('lang');
      let color;

      switch (activity.status) {
        case 'Advancement':
          color = '#155D77';
          break;
        case 'Overdue':
          color = '#E50101';
          break;
        case 'Waiting':
          color = '#121212';
          break;
        case 'Doing':
          color = '#F59D04';
          break;
        case 'Done':
          color = '#34AF00';
          break;
        default:
          color = '#121212';
          break;
      }

      const progressValue = parseFloat(activity.progress).toFixed(2);
      const displayProgress = lang === 'en' ? `${progressValue}%` : `${progressValue.replace('.', ',')}%`;

      return `
        <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; color: ${color};">
          ${displayProgress}
        </div>
      `;
    },
    hide: !isVisible,
    data_type: 'number',
    groupable: false,
    orderable: true,
    orderable_switch: ['1 → 9', '9 → 1'],
    filterable: true,
  };
};

export default progressCol; 